module.exports = "../img/Tarjeta_ClubLN.png";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Tarjeta_ClubLN.png
// module id = 61
// module chunks = 0